export enum SecurableActivityType {
  NotSet = 0,
  AllowDeny = 1,
  CRUD = 2
}
